import { render, staticRenderFns } from "./DashboardCharts.vue?vue&type=template&id=2cb36f4a&scoped=true&"
import script from "./DashboardCharts.vue?vue&type=script&lang=ts&"
export * from "./DashboardCharts.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardCharts.vue?vue&type=style&index=0&id=2cb36f4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb36f4a",
  null
  
)

export default component.exports